<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <div class="contents">
        <b-form @submit.prevent="passes(onSubmit)">
          <div class="row g-0 table-type header-col">
            <div class="col-sm-4">
              <span class="required">{{ $t("title.common.name") }}</span>
            </div>
            <div class="col-sm-8">
              <input type="text" placeholder="" v-model="form.name" required />
            </div>

            <div class="col-sm-4">
              <span class="required">{{ $t("title.common.id") }}</span>
            </div>
            <div class="col-sm-8">
              <input type="text" placeholder="" v-model="form.id" required />
            </div>

            <div class="col-sm-4">
              <span class="required">{{ $t("title.common.password") }}</span>
            </div>
            <div class="col-sm-8">
              <input type="password" placeholder="" v-model="form.password" />
            </div>

            <div class="col-sm-4">
              <span class="required">{{
                $t("title.admin.password_confirm")
              }}</span>
            </div>
            <div class="col-sm-8">
              <input
                type="password"
                placeholder=""
                v-model="form.password_re"
              />
            </div>

            <div class="col-sm-4">
              <span class="required">{{ $t("title.admin.part") }}</span>
            </div>
            <div class="col-sm-8">
              <select
                class="form-select-lg"
                v-model="form.part"
                @dataChanged="partChange"
              >
                <option value="1">{{ $t("filter.admin.management") }}</option>
                <option value="2">{{ $t("filter.admin.technology") }}</option>
                <option value="3">
                  {{ $t("filter.admin.customer_support") }}
                </option>
                <option value="4">
                  {{ $t("filter.admin.manufacturing") }}
                </option>
                <option value="5">
                  {{ $t("filter.admin.overseas_sales") }}
                </option>
              </select>
            </div>

            <div class="col-sm-4">
              <span class="required">{{ $t("title.admin.position") }}</span>
            </div>
            <div class="col-sm-8">
              <select
                class="form-select-lg"
                v-model="form.position"
                @dataChanged="positionChange"
              >
                <option value="1">{{ $t("filter.admin.employee") }}</option>
                <option value="2">{{ $t("filter.admin.deputy") }}</option>
                <option value="3">{{ $t("filter.admin.manager") }}</option>
                <option value="4">
                  {{ $t("filter.admin.team_leader") }}
                </option>
                <option value="5">{{ $t("filter.admin.deputy") }}</option>
                <option value="6">{{ $t("filter.admin.general") }}</option>
                <option value="7">{{ $t("filter.admin.director") }}</option>
              </select>
            </div>

            <div class="col-sm-4">
              <span class="required">{{ $t("title.admin.phone") }}</span>
            </div>
            <div class="col-sm-8">
              <input type="text" placeholder="" v-model="form.phone" required />
            </div>

            <div class="col-sm-4">
              <span class="required">{{ $t("title.common.email") }}</span>
            </div>
            <div class="col-sm-8">
              <input type="text" placeholder="" v-model="form.email" required />
            </div>

            <div class="col-sm-4">
              <span class="required">{{ $t("title.common.status") }}</span>
            </div>
            <div class="col-sm-8">
              <select
                class="form-select-lg"
                v-model="form.status"
                @dataChanged="statusChange"
              >
                <option value="0">{{ $t("filter.admin.suspended") }}</option>
                <option value="1">{{ $t("filter.admin.active") }}</option>
              </select>
            </div>
          </div>

          <div class="btn-bottom-wrapper">
            <b-button
              size="xl"
              variant="outline-primary"
              :aria-label="$t('button.common.list')"
              @click="$router.push({ name: 'ManagerList' })"
              >{{ $t("button.common.list") }}</b-button
            >
            <b-button
              size="xl"
              variant="primary"
              :aria-label="$t('button.common.save')"
              type="submit"
              >{{ $t("button.common.save") }}</b-button
            >
          </div>
        </b-form>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import "@/filter/common";
import options from "@/config/options";
import { ValidationObserver } from "vee-validate";
import InputWithValidation from "@/components/common/validations/inputbox";
import SelectBoxWithValidation from "@/components/common/validations/selectbox";
import ax from "@/api/manager";

export default {
  name: "Adminwrite",
  components: {
    ValidationObserver,
  },
  data() {
    return {
      form: {
        adminno: this.$route.params.adminno || "",
        name: "",
        id: "",
        password: null,
        password_re: null,
        part: 1,
        position: 1,
        phone: "",
        email: "",
        status: 1,
      },
      partOptions: options.partOptions,
      positionOptions: options.positionOptions,
      statusOptions: options.statusOptions,
      adminno: this.$route.params.adminno || "",
    };
  },
  created() {
    if (this.adminno) {
      this.getView();
    }
  },
  methods: {
    onSubmit() {
      // if (this.form.password != this.form.password_re) {
      //   alert(this.$i18n.t("alert.common.password_not_match"));
      //   return false;
      // }

      if (!this.adminno) {
        // 등록
        ax.setManager(this.form, (flag, data) => {
          if (flag) {
            alert(data.message);
            this.$router.push({ name: "ManagerList" });
          } else {
            alert(data.message);
            return false;
          }
        });
      } else {
        // 수정
        this.form.adminno = this.adminno;
        ax.modiManager(this.form, (flag, data) => {
          if (flag) {
            alert(data.message);
          } else {
            alert(data.message);
            return false;
          }
        });
      }
    },
    getView() {
      ax.getView(this.adminno, (flag, data) => {
        if (flag) {
          this.form = data.admininfo;
        } else {
          alert(data.message);
        }
      });
    },
    partChange(v) {
      this.form.part = v;
    },
    positionChange(v) {
      this.form.position = v;
    },
    statusChange(v) {
      this.form.status = v;
    },
  },
};
</script>
